
import { BrowseState } from "@/utils/browse/browse-state";
import { IQueryParams } from "@/utils/query-params";
import Vue from "vue";
import { IDataTableColumn, IDataTableContextMenuEvent } from "winfakt-vue-components";
import { getModel, Model } from "@/utils/models/model";
import { AuthService } from "@/services/auth-service";
import { ViewService } from "@/services/view-service";
import { Sale } from "@/models/base";
import AppJsonViewerModal from "@/components/common/JsonViewerModal.vue";
import AppBrowseContextMenu from "./BrowseContextMenu.vue";
import { UserConfigService } from "@/services/user-config-service";
import { Condition } from "@/utils/condition/condition";

export default Vue.extend({
	data() {
		return {
			spinnerShown: false,
			jsonViewerObject: null as any,
			emptyLabel: this.$ct("fetching").toString(),
			UserConfigService
		};
	},

	props: {
		state: {
			required: true,
			type: Object as () => BrowseState
		},
	},

	computed: {
		useCheckboxes():boolean {
			return this.state.useCheckboxes();
		},
		useCompactView():boolean {
			return this.UserConfigService.getGeneralSettings().CompactView;
		},
		modelDefinition(): Model {
			return getModel(this.state.dataSource.modelName);
		},
		selectedItems():any[] {
			return this.state.selectedItems;
		},
		querySettings():IQueryParams {
			return this.state.querySettings;
		},
		items():any[] {
			return this.state.queryResults.data;
		},
		isDemo(): Boolean{
			return AuthService.wfCompany.IsDemo || document.getElementById("renew-box") != null;
		},
		columns(): IDataTableColumn[] {
			return this.state.getDataTableColumns(this.modelDefinition);
		},
		borderBottomRightRadius():undefined | string {
			if (this.state.hasTotals()) {
				return "0px";
			}
			return undefined;
		},
	},

	watch: {
		"state.fetching"(value:boolean) {
			this.emptyLabel = this.$ct("fetching").toString();
			if (!value) {
				this.emptyLabel = this.$ct("empty").toString();
				this.spinnerShown = false;
			}
		},
		contextMenuOpened: {
			handler(value:boolean) {
				if (!value) return;
				requestAnimationFrame(() => {
					let items = this.$refs.selectItems as Vue[];
					if (!items) return;
					if (!items[0]) return;
					(items[0] as any).focus();
				});
			}
		}
	},

	methods: {
		onOrderChanged(order: { order: any, ascending: boolean }) {
			this.querySettings.orderBy = order.order;
			this.querySettings.orderDirection = !order.ascending ? "ASC" : "DESC";
			this.state.fetch();
		},
		openJsonViewer(item:any){
			if (!AuthService.isDevModeEnabled) return;
			this.jsonViewerObject = item;
		},

		onContextMenuClick(event:IDataTableContextMenuEvent) {
			if (event.event.ctrlKey){
				return this.openJsonViewer(event.item);
			}
			if (this.$wf.isSmDown) return;
			this.state.contextMenu.onContextMenuClick(event, this.selectedItems);
		},

		onScroll(event:Event) {
			let table = event.target as HTMLElement;
			let lastChild = table.lastChild as HTMLElement;
			if (!lastChild) {
				return;
			}

			let tableRect = table.getBoundingClientRect();
			let childRect = lastChild.getBoundingClientRect();


			let tableBottomY = tableRect.top + tableRect.height;
			if (childRect.top < (tableBottomY + 4000) && !this.state.fetching) {
				this.state.infiniteScrollFetchMore();
			}
		},
		openItem(item:any) {
			if(this.state.browse.ID==6){
				if(this.state.selectedItems[0] && (this.state.selectedItems[0] as Sale).ComputedFriendlyID.charAt(0)=="-"){
					this.$wf.dialog(this.$ct("saldo-warning"), this.$ct("common.Ok"), this.$ct("common.attention"), "info");
					return true;
				}
			}

			let customButton = this.state.getDoubleClickCustomButton();
			if (customButton) {
				this.state.openCustomButton(customButton, [item]);
				return;
			}

			if (this.state.sidebar.opensOnDoubleClick) {
				this.state.openSidebar(item);
				return;
			}

			const doubleClickOpensEdit = UserConfigService.getGeneralSettings().DoubleClickOpensEdit;
			const editAvailable = !this.state.isButtonHidden("edit");
			const infoAvailable = !!this.state.dataSource.info && !this.state.isButtonHidden("info");

			if (doubleClickOpensEdit && editAvailable) {
				this.state.dataSource.edit(item);
			} else if (infoAvailable) {
				this.state.dataSource.info!(item);
			} else if (editAvailable) {
				this.state.dataSource.edit(item);
			}
		},
		async onNewColumnWidth(columnIndex:number){
			let width = this.columns[columnIndex].width;
			let view = this.state.querySettings.view;
			if (!width) {
				view.Columns[columnIndex].Width = "100px";
			}else{
				view.Columns[columnIndex].Width = width;
			}
			if (view.ID == 0) return;
			await ViewService.setColumnWidths(view.ID, view.Columns.map(c=>c.Width));
		},

		getStyleFunction(item:any):any{
			for (let highlight of this.state.querySettings.view.Highlights){
				if (Condition.checkConditions(highlight.Conditions, item)){
					return highlight.Style.getStyle();
				}
			}
			return null;
		}
	},
	components: {
		AppJsonViewerModal,
		AppBrowseContextMenu
	},

	i18nEx: {
		componentPrefix: "components.browse"
	}
});
